import React, { useEffect, useState } from "react";
import axios from "axios";
import axiosConfig from "../../axiosConfig";
import GetUser from "../../services/auth.getUser";
import { makeStyles } from '@material-ui/core';
import jwt_decode from "jwt-decode";
import NotificationsActiveIcon from "@material-ui/icons/NotificationsActive";
import Warning from "@material-ui/icons/Warning";
import { Card, CardHeader, CardIcon, CardFooter } from "../../shared/Card/Index";
import styles from "../../shared/dashboardStyle"

const useStyles = makeStyles(styles)


const ClosuersByMinutesPerUser = ({ className, ...rest }) => {
    const classes = useStyles();
    const [pendingAlarms, setPendingAlarms] = useState(0);
    const [pendingAlarmsCount, setPendingAlarmsCount] = useState(0);

    const getTheUser = GetUser();

    const decodedToken = jwt_decode(getTheUser.accessToken);
    const Username = decodedToken.Username;

    useEffect(() => {
        const promise1 = axiosConfig.get(
            `Statistics/GetAvgTimesPerUser?dtFrom=2020-09-01&dtTo=2025-11-6`
        );

        const promise2 = axiosConfig.get(
            `Statistics/GetCountOfAlarmsPerUser?dtFrom=2020-09-01&dtTo=2025-11-6`
        );
        axios
            .all([promise1, promise2])
            .then(
                axios.spread((...res) => {
                    const responseOne = res[0];
                    responseOne.data.forEach((element, index) => {
                        if (element.xeiristis === Username) {
                            setPendingAlarms(element.closureTime)
                        }
                    });

                    const responseTwo = res[1];
                    responseTwo.data.forEach((element, index) => {
                        if (element.xeiristis === Username) {
                            setPendingAlarmsCount(element.cntOfClosed)
                        }
                    });
                })
            )
            .catch((err) => {
                console.log(err);
            });
    }, []);

    return (
        <Card>
            <CardHeader color="warning" stats icon>
                <CardIcon color="warning">
                    <NotificationsActiveIcon />
                </CardIcon>
                <p className={classes.cardCategory}>Μέσος Χρόνος Κλεισίματος</p>
                <h3 className={classes.cardTitle}>{pendingAlarms}</h3>
            </CardHeader>
            <CardFooter stats>
                <div className={classes.stats}>
                    <Warning />
                    {pendingAlarmsCount} ειδοποιήσεις έκλεισαν
                </div>
            </CardFooter>
        </Card>
    );
};


export default ClosuersByMinutesPerUser;